import { useRouter } from 'next/router';
import { useMemo } from 'react';

const HIDDEN_CATEGORY_MAP: Record<string, string[]> = {
  aX9Tq: ['mathematics'],
};

const useHiddenCategories = () => {
  const router = useRouter();
  const variant = router.query.variant_token;

  const hiddenCategories = useMemo(() => {
    if (typeof variant === 'string') {
      return HIDDEN_CATEGORY_MAP[variant] || [];
    }
    return [];
  }, [variant]);

  return hiddenCategories;
};

export default useHiddenCategories;
